import { render, staticRenderFns } from "./LeftBehind.vue?vue&type=template&id=125b5230&scoped=true"
import script from "./LeftBehind.vue?vue&type=script&lang=js"
export * from "./LeftBehind.vue?vue&type=script&lang=js"
import style0 from "./LeftBehind.vue?vue&type=style&index=0&id=125b5230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b5230",
  null
  
)

export default component.exports